import React from 'react';
import { ColumnContent } from './SortableList';
import classnames from 'classnames';
import { Icon } from '../Icon/Icon';
import { Tooltip } from '../Tooltip/Tooltip';

interface Props<T> {
  column: ColumnContent<T>;
  sortBy?: string;
  sortAscending?: boolean;
  onColumnClick: (columnKey: Extract<keyof T, string>) => void;
}

export function ColumnHeader<T>({ column, sortBy, sortAscending, onColumnClick }: Props<T>): JSX.Element {
  const labelNode = <div className="sortable-list__label">{column.label}</div>;

  return (
    <th
      style={{ width: column.width }}
      className={classnames('sortable-list__header', {
        'sortable-list__header--sortable': column.sortable,
        'sortable-list__with-separator': column.separator,
        'sortable-list__label--align-right': column.labelAlign === 'right',
      })}
      onClick={() => onColumnClick(column.dataKey)}
    >
      <div className="sortable-list__header-wrapper">
        {column.tooltip !== undefined ? (
          <Tooltip className="sortable-list__tooltip" reference={labelNode} position={column.tooltip.position}>
            {column.tooltip.content}
          </Tooltip>
        ) : (
          labelNode
        )}
        {column.apiSortIcon || (
          <>
            {column.sortable && column.dataKey !== sortBy && <Icon name="arrow-sortable" />}
            {column.sortable && column.dataKey === sortBy && sortAscending && <Icon name="arrow-sortable-asc" />}
            {column.sortable && column.dataKey === sortBy && !sortAscending && <Icon name="arrow-sortable-desc" />}
          </>
        )}
      </div>
    </th>
  );
}
